// extracted by mini-css-extract-plugin
export default {"formWrapper":"activity_edit_form___formWrapper___b20fb8a2"};